import { type DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const InTrialFeatureGatesBannerQuery: DocumentNode = gql`
	query InTrialFeatureGatesBannerQuery($cloudId: ID!) {
		tenantContexts(cloudIds: [$cloudId])
			@optIn(to: ["CcpAllUserUpgradeAndPay", "HamsAllUserUpgradeAndPay"]) {
			entitlementInfo(hamsProductKey: "confluence.ondemand") {
				entitlement(where: { AND: [{ inTrialOrPreDunning: true }] }) {
					subscription {
						trial {
							endTimestamp
						}
						accountDetails {
							invoiceGroup {
								invoiceable
								experienceCapabilities {
									configurePaymentV2 {
										experienceUrl
										isAvailableToUser
									}
									configurePayment {
										experienceUrl
										isAvailableToUser
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;
